import styled from 'styled-components';
import Input from './Input';
import Label from './Label';

const CheckboxGroup = styled.div`
  position: relative;

  ${Input} {
    &[type='checkbox'] {
      width: initial;
      position: absolute;
      opacity: 0;
      outline: 0;
      width: 24px;
      height: 24px;

      + ${Label} {
        padding-left: 24px;
        font-weight: normal;
        margin-bottom: 0px;
      }

      + ${Label}::before {
        position: absolute;
        top: 4px;
        left: 0;
        width: 16px;
        height: 16px;
        content: '';
        background: #fff;
        border: 1px solid ${({ theme }) => theme.form.color.border};
        border-radius: 2px;
      }

      + ${Label}::after {
        position: absolute;
        font-size: 14px;
        top: 1px;
        left: 0;
        width: 17px;
        height: 17px;
        text-align: center;
      }

      &:checked + ${Label}::after {
        content: '\f00c';
        font-family: 'FontAwesome';
      }

      &:focus + ${Label}::before {
        border-color: ${({ theme }) => theme.form.color.borderFocus};
      }
    }
  }
`;

export default CheckboxGroup;
